module.exports = __webpack_public_path__ + "static/media/sound.f4e86dd3.png";